import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ChiSono from "./pages/ChiSono";
import Gastronomia from "./pages/Gastronomia";
import PersonalChef from "./pages/PersonalChef";
import Ordina from "./pages/Ordina";
import Contatti from "./pages/Contatti";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chi-sono" element={<ChiSono />} />
          <Route path="/gastronomia" element={<Gastronomia />} />
          <Route path="/personal-chef" element={<PersonalChef />} />
          <Route path="/ordina" element={<Ordina />} />
          <Route path="/contatti" element={<Contatti />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;